import UppyFactory from '../../../../factory/uppy';

const DesignFacade = require('../../../../facade/design/design');
const ImagesFactory = require('../../../../factory/images');
const RestrictionsFactory = require('../../../../factory/restrictions');

const BaseView = require('./abstract-type');
const ElementListView = require('./element-list/view');
const template = require('./image-type.hbs');

module.exports = BaseView.extend({
  type: 'image',
  basicHide: ['image_add', 'image_replace', 'image_z_index'],

  selectSpecifyFolder: function () {
    document.querySelector('#element-restrictions-source').checked = false;
    document.querySelector('#element-restrictions-folder').checked = true;
    const sourceList = this.el.querySelector('.image-replacement-options');
    const folderList = this.el.querySelector('.image-replacement-folders');
    sourceList.classList.toggle('hidden', true);
    folderList.classList.toggle('hidden', false);
    this.sourceListView.removeAllElement();
    this.recalculateSectionHeight(
      document.querySelector('#element-restrictions-folder')
    );
  },

  selectSpecifySource: function () {
    document.querySelector('#element-restrictions-source').checked = true;
    document.querySelector('#element-restrictions-folder').checked = false;
    const sourceList = this.el.querySelector('.image-replacement-options');
    const folderList = this.el.querySelector('.image-replacement-folders');
    sourceList.classList.toggle('hidden', false);
    folderList.classList.toggle('hidden', true);
    this.initAddButton();
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-source'));
  },

  toggleSectionEvent: function (event) {
    const option = event.currentTarget;
    const sectionName = option.closest('.restrictions.group').getAttribute('data-name') || 'basic';
    const name = option.getAttribute('name') || option.closest('.restrictions.group[data-field]')?.getAttribute('data-field');
    const value = this.getOptionValue($(option));

    if (option.checked && option.id === 'element-restrictions-source' && !this.sourceListView.getData().length) {
      this.sourceListView.addElement(this.selection.source.url);
    }

    if (sectionName === 'basic' && name === 'image_content') {
      const source = this.el.querySelector('div[data-name="source"]');
      const sourceList = this.el.querySelector('.image-replacement-options');
      const folder = this.el.querySelector('div[data-name="folder"]');
      const folderList = this.el.querySelector('.image-replacement-folders');
      const specialImageInput = source.querySelector('#element-restrictions-source');
      const folderImageInput = this.el.querySelector('#element-restrictions-folder');

      source.classList.toggle('hidden', !value);
      folder.classList.toggle('hidden', !value);
      sourceList.classList.toggle('hidden', true);
      folderList.classList.toggle('hidden', true);
      const initialSpecialImageInputChecked = specialImageInput.checked;

      specialImageInput.checked = false;
      folderImageInput.checked = false;
      value || this.sourceListView.removeAllElement();
      value && this.initAddButton();
      initialSpecialImageInputChecked && this.onSectionChange(specialImageInput);
    }

    if (sectionName === 'folder') {
      this.selectSpecifyFolder();
    }

    if (sectionName === 'source') {
      this.selectSpecifySource();
    }

    this.recalculateSectionHeight(option);

    BaseView.prototype.toggleSectionEvent.apply(this, arguments);
  },

  render: async function () {
    const someGroup = _(this.groups).find(function (group) {
      return group.permissions && group.permissions.template;
    });

    if (!someGroup) return;

    const basicPermissions = _.chain(someGroup.permissions.template)
      .map(function (value, index) {
        return {
          name: index,
          tag: 'tool.restrictions.template.permission.' + index
        };
      })
      .filter(function (field) {
        return this.basicHide.indexOf(field.name) < 0;
      }, this)
      .filter(function (field) {
        return field.name.match(/^image_/);
      }).value();
    const excludedRestrictions = ['image_crop', 'image_size', 'image_filter', 'image_opacity', 'image_content', 'image_z_index'];
    this.$el.html(template({ basic: this.sortElementPermissions('image', basicPermissions).filter((p) => !excludedRestrictions.includes(p.name)) }));
    this.initSourceList();
    await this.initLibraryFolders(this.type);
    this.renderRestrictions();
    this.renderDisabled();
  },

  remove: function () {
    if (this.folderRestrictionView) {
      this.folderRestrictionView.closeApp();
    }
  },

  getOptionValue: function ($option) {
    if ($option.is('.element-list')) return this.sourceListView.getData();
    return BaseView.prototype.getOptionValue.apply(this, arguments);
  },

  _renderRestrictions: function (restrictions, sectionName) {
    BaseView.prototype._renderRestrictions.apply(this, arguments);

    if (sectionName === 'source' && restrictions[sectionName] && restrictions[sectionName].list) {
      _(restrictions[sectionName].list).each(this.sourceListView.addElement);
      setTimeout(() => this.selectSpecifySource(), 150);
    }

    if (sectionName === 'folder' && restrictions.source && restrictions.source.library_folder) {
      setTimeout(() => this.selectSpecifyFolder(), 150);
    }
  },

  updateRestrictions: async function (data) {
    const ePermissions = await RestrictionsFactory.getElementPermissions();
    const permission = ePermissions.find(permission => {
      return permission.page_number === INKIVE.Tool._current_page_number &&
        permission.element_id === this.selection.id;
    });

    const restrictions = permission ? JSON.parse(permission.restrictions) : {};

    if (restrictions.source && restrictions.source.list) {
      if (!restrictions.source.list.map((source) => ImagesFactory.getVersionUrl(source, 'thumb')).includes(data.tempLink)) {
        INKIVE.Tool.getInstance().editor.canvas.call('advice.show', 'source-restriction-applied');
        restrictions.source.list.push(data.tempLink);

        RestrictionsFactory.setGlobalElementRestriction(
          this.selection.id, JSON.stringify(restrictions)
        );
      }

      for (const source of restrictions.source.list) {
        this.sourceListView.addElement(source);
      }
    }

    this.recalculateSectionHeight(document.querySelector('#element-restrictions-source'));
    this.initAddButton();
  },

  renderDisabled: function () {
    const replaceImageInput = this.el.querySelector('.element-restriction-options label.switch input[type="checkbox"]');
    const replaceImageSubInput = this.el.querySelector('.element-restriction-sub-options label.switch input[type="radio"]');
    const isReplaceOn = this.getOptionValue($(replaceImageInput));
    const isReplaceSpecifiedOn = this.getOptionValue($(replaceImageSubInput));
    replaceImageInput && this.el.querySelector('div[data-name="source"]').classList.toggle('hidden', !isReplaceOn);
    replaceImageInput && this.el.querySelector('div[data-name="folder"]').classList.toggle('hidden', !isReplaceOn);
    replaceImageInput && replaceImageSubInput && this.el.querySelector('.image-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedOn));
    this.recalculateSectionHeight(replaceImageInput);
  },

  persistOptionRestriction: function ($option) {
    const sectionName = $option.closest('.restrictions.group').data('name') || 'basic';
    const name = $option.attr('name') || $option.closest('.restrictions.group[data-field]').data('field');

    if (sectionName === 'basic' && name === 'image_content') {
      const value = this.getOptionValue($option);
      value && this.checkRepositionPermission();
    }

    BaseView.prototype.persistOptionRestriction.call(this, $option);
  },

  checkRepositionPermission: function () {
    RestrictionsFactory.getElementPermissions().then(_.bind(function (ePermissions) {
      const permission = _(ePermissions).findWhere({
        page_number: INKIVE.Tool._current_page_number,
        element_id: this.selection.id
      });

      const r = permission ? JSON.parse(permission.restrictions) : {};
      const cropUnset = !r.basic || typeof r.basic.image_crop === 'undefined';
      const imageContentUnset = !r.basic || typeof r.basic.image_content === 'undefined';
      const cropByDefault = RestrictionsFactory.getTemplatePermissionsCollection()
        .any(function (templatePermissions) { return templatePermissions.image_crop; });

      if (cropUnset && !cropByDefault) {
        r.basic = r.basic || {};
        r.basic.image_crop = true;
        if (imageContentUnset) {
          r.basic.image_content = true;
        }

        INKIVE.Tool.getInstance().editor.canvas
          .call('advice.show', 'crop-restriction-applied');

        this.$el.find('#template-restriction-image_crop').prop('checked', true);
        RestrictionsFactory.setGlobalElementRestriction(
          this.selection.id, JSON.stringify(r)
        );
      }
    }, this));
  },

  initSourceList: function () {
    this.sourceListView && this.sourceListView.remove();
    this.sourceListView = new ElementListView({
      el: this.$el.find('.image-replacement-options li'),
      type: this.type
    });

    this.sourceListView.on('change', (data, type) => {
      const $input = this.sourceListView.$el.find('input');
      this.persistOptionRestriction($input);

      if (type === 'removed') this.initAddButton();
    });

    this.sourceListView.on('apply', function (url) {
      DesignFacade.set({ source: { url }, keep_box_size: true });
    });
  },

  initAddButton: function () {
    const addButton = this.el.querySelector(
      '.image-replacement-options ul.options li .thumbnails-wrapper .add-new'
    );

    const opts = {
      restrictions: {
        allowedFileTypes: ['image/png', 'image/jpeg']
      },
      onFileUploaded: this.updateRestrictions.bind(this)
    };

    this.uppyFactory = new UppyFactory({
      id: `uppy-library-${this.type}`,
      button: addButton,
      loadtype: this.type,
      restrictions: opts.restrictions,
      onFileUploaded: opts.onFileUploaded
    });

    this.uppyFactory.initUppyManager();
  }
});
